import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FloatingBubbles from '../components/FloatingBubbles';
import axios from 'axios';

export default function VerifyEmail() {
  const { API } = useAuth();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    axios.get(`${API}/auth/verify-email?token=${token}`)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token, API]);

  return (
    <>
      <FloatingBubbles />
      <div style={{ position: 'relative', zIndex: 1, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div style={{ width: '100%', maxWidth: '420px', background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)', borderRadius: '20px', padding: '40px 32px', boxShadow: '0 8px 32px rgba(43,108,176,0.12)', border: '1px solid rgba(190,227,248,0.4)', textAlign: 'center' }}>
          {status === 'loading' && (
            <>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: 'var(--dark)' }}>Vérification en cours...</h2>
            </>
          )}
          {status === 'success' && (
            <>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: 'var(--dark)', marginBottom: '12px' }}>Email vérifié !</h2>
              <p style={{ fontSize: '14px', color: 'var(--text)', lineHeight: 1.7, marginBottom: '24px' }}>Ton adresse email a bien été vérifiée. Tu peux maintenant profiter de toutes les fonctionnalités d'Agora.</p>
              <Link to="/" style={{ background: 'var(--blue)', color: '#fff', padding: '12px 28px', borderRadius: '24px', fontSize: '14px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', boxShadow: '0 4px 12px rgba(43,108,176,0.3)' }}>Aller sur Agora →</Link>
            </>
          )}
          {status === 'error' && (
            <>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>❌</div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: 'var(--dark)', marginBottom: '12px' }}>Lien invalide</h2>
              <p style={{ fontSize: '14px', color: 'var(--text)', lineHeight: 1.7, marginBottom: '24px' }}>Ce lien est invalide ou a expiré. Connecte-toi et demande un nouveau lien de vérification.</p>
              <Link to="/login" style={{ color: 'var(--blue)', fontWeight: 600, fontSize: '14px' }}>← Se connecter</Link>
            </>
          )}
        </div>
      </div>
    </>
  );
}
